import { createFileRoute } from '@tanstack/react-router'
import { ServiceJobPage } from '../../../../../features/service/job-page'

export const Route = createFileRoute('/_app/service/jobs/$jobId/')({
  component: ServiceJobPage,
})
